// ================================================================
// TABOOLA x BREEZE CHECKOUT TRACKING — newjaisa.com
// page_view / view_content / add_to_cart / search are handled by
// the Shopify custom pixel. This file ONLY fires checkout-stage
// events emitted by Breeze on the parent page.
// ================================================================
const TABOOLA_ACCOUNT_ID = 2077117;

window._tfa = window._tfa || [];
// NOTE: intentionally NO page_view push here — the Shopify custom
// pixel already tracks page views. Pushing it here would double-count.

// Load Taboola Pixel SDK (needed on the main page for the pushes below)
(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = true;
    t.src = a;
    t.id = x;
    f.parentNode.insertBefore(t, f);
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  "//cdn.taboola.com/libtrc/unip/" + TABOOLA_ACCOUNT_ID + "/tfa.js",
  "tb_tfa_script"
);

// ---------------- helpers ----------------
function getOrderValue(params) {
  const totalPrice = Number(params?.totalPrice);
  if (!Number.isFinite(totalPrice)) return 0;
  // Breeze sends the value in paise.
  return totalPrice / 100;
}

function getItemQuantity(items) {
  if (!Array.isArray(items)) return 0;
  return items.reduce((total, item) => {
    const quantity = Number(item?.quantity);
    return total + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
  }, 0);
}

function trackTaboolaEvent(eventName, params = {}) {
  try {
    window._tfa = window._tfa || [];
    window._tfa.push({
      notify: "event",
      name: eventName,
      id: TABOOLA_ACCOUNT_ID,
      ...params
    });
    console.log("✅ Taboola event fired:", eventName, params);
  } catch (error) {
    console.error("❌ Taboola event error:", eventName, error);
  }
}

// ---------------- start_checkout ----------------
window.addEventListener("breeze-initiate-checkout", function (event) {
  if (!event.detail || !event.detail.data) {
    console.error("❌ Taboola Checkout: Invalid event data");
    return;
  }
  try {
    if (window.__taboolaCheckoutFired) {
      console.warn("⚠️ Duplicate Taboola checkout blocked");
      return;
    }
    window.__taboolaCheckoutFired = true;
    trackTaboolaEvent("start_checkout", {
      revenue: getOrderValue(event.detail.data),
      currency: event.detail.data?.currency || "INR",
      quantity: getItemQuantity(event.detail.data?.items)
    });
  } catch (error) {
    console.error("❌ Taboola Checkout Error:", error);
  }
});

// ---------------- make_purchase ----------------
window.addEventListener("breeze-purchase", function (event) {
  if (!event.detail || !event.detail.data) {
    console.error("❌ Taboola Purchase: Invalid event data");
    return;
  }
  const params = event.detail.data;
  try {
    const orderId = String(params?.shopOrderId || params?.orderId || "");
    const deduplicationKey = orderId || String(params?.totalPrice || "unknown");
    window.__taboolaPurchaseOrders = window.__taboolaPurchaseOrders || {};
    if (window.__taboolaPurchaseOrders[deduplicationKey]) {
      console.warn("⚠️ Duplicate Taboola purchase blocked:", deduplicationKey);
      return;
    }
    window.__taboolaPurchaseOrders[deduplicationKey] = true;
    trackTaboolaEvent("make_purchase", {
      revenue: getOrderValue(params),
      currency: params?.currency || "INR",
      quantity: getItemQuantity(params?.items),
      orderid: orderId
    });
  } catch (error) {
    console.error("❌ Taboola Purchase Error:", error);
  }
});

// ---------------- add_payment_info (optional extra) ----------------
window.addEventListener("breeze-add-payment-info", function (event) {
  if (!event.detail || !event.detail.data) return;
  try {
    if (window.__taboolaPaymentInfoFired) return;
    window.__taboolaPaymentInfoFired = true;
    trackTaboolaEvent("add_payment_info", {
      revenue: getOrderValue(event.detail.data),
      currency: event.detail.data?.currency || "INR",
      quantity: getItemQuantity(event.detail.data?.items)
    });
  } catch (error) {
    console.error("❌ Taboola Payment Info Error:", error);
  }
});